module.exports = __webpack_public_path__ + "img/chat-open-bg.ccb931d.png";